// extracted by mini-css-extract-plugin
module.exports = {"description":"ProductPurchase_description__kF7fk","subtitle":"ProductPurchase_subtitle__TYuDZ"};